import AllhomesFooter from './allhomes-footer';
export default AllhomesFooter;